import {
  createBrowserRouter,
} from 'react-router-dom';

import App from './containers/App';
import ErrorPage from './containers/ErrorPage';
import MyAccountPage from './containers/MyAccountPage';
import TermsOfUsePage from './containers/TermsOfUsePage';
import config from './client/config';
import { RequireAuth } from './hooks/useAuthGuard';
import { ProjectConfigurationProvider } from './hooks/useProjectConfiguration';
import ErrorClientPage from './containers/ErrorClientPage';
import DeviceLimitPage from './containers/DeviceLimitPage';

const router = createBrowserRouter(
  [
    {
      element: <App />,
      errorElement: <ErrorPage />,
      id: 'root',
      path: '/'
    },
    {
      element:  <ErrorClientPage />,
      path: `${config.clientShortName}/myaccount/:cp/error/:errorCode`
    },
    {
      element: <DeviceLimitPage/>,
      path: `${config.clientShortName}/devices/limit`
    },
    {
      element: (
        <RequireAuth>
          <ProjectConfigurationProvider>
            <MyAccountPage />
          </ProjectConfigurationProvider>
        </RequireAuth>
      ),
      errorElement: <ErrorPage />,
      path: `${config.clientShortName}/myaccount`
    },
    {
      element: <TermsOfUsePage />,
      path: `${config.clientShortName}/:cp/termsofuse`
    },
    {
      element: <ErrorPage geoBlocking />,
      path: '/error/geoblocking'
    }
  ]
);

export default router;
